import React from 'react';

import {
    JRCInputTinyMCERaw,
    JRCInputTinyMCERawProps,
} from 'components/Form/Input/JRCInputTinyMCERaw/JRCInputTinyMCERaw';
import { WidgetDisplayMode } from 'jamespot-user-api';

import { useIntl } from 'react-intl';
import { JRCHtml } from 'components/JRCHtml/JRCHtml';
import { CSSText } from '../styles';
import { TinyMCEExtension } from 'components/Form/Input/JRCInputTinyMCERaw/extensions/JTinyMCEExtensions';

export type JRCWidgetArticleTextProps = {
    text: string;
    autoFocus?: boolean;
    token: string;
    mode?: WidgetDisplayMode;
    onChange: (text: string) => void;
    additionalExtensions?: Array<TinyMCEExtension>;
    tinyMCECommonOptions?: Pick<JRCInputTinyMCERawProps, 'commonOptions' | 'mentionsQueries'> &
        Partial<Pick<JRCInputTinyMCERawProps, 'tinymceScriptSrc'>>;
};

export const JRCWidgetArticleText = ({
    text,
    autoFocus,
    token,
    mode,
    onChange,
    additionalExtensions,
    tinyMCECommonOptions,
}: JRCWidgetArticleTextProps) => {
    const intl = useIntl();
    if (mode !== 'edit' || tinyMCECommonOptions === undefined) {
        return (
            <CSSText>
                <JRCHtml __html={text} className="widget-text-html" />
            </CSSText>
        );
    }

    return (
        <JRCInputTinyMCERaw
            {...tinyMCECommonOptions}
            value={text ?? ''}
            autoFocus={autoFocus}
            onChange={onChange}
            placeholder={intl.formatMessage({ id: 'WIDGET_Article_Text_Placeholder' })}
            token={token}
            additionalExtensions={additionalExtensions}
        />
    );
};
